import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import { componentsFontSizes } from 'src/constants/layout';
import { SubSystemCommonProps } from './site-documentation.types';

export function useCommonProps(disabled = false): SubSystemCommonProps {
  const theme = useTheme();

  const commonProps = useMemo<SubSystemCommonProps>(
    () => ({
      disabled,
      textFieldProps: {
        size: 'small',
        sx: {
          '& .MuiInput-input': {
            ...theme.typography.body2,
            fontSize: (theme) => theme.utils.important(componentsFontSizes.input),
            paddingInline: 1.6,
            paddingBlock: 1,
            textAlign: 'end',
          },
          '&:hover, &:focus-within': {
            background: (theme) => theme.palette.custom.OV.sys.surface,
          },

          '.Mui-focused &': {
            background: 'inherit',
          },
        },
        disabled,
      },
      inputProps: {
        sx: {
          ...theme.typography.body2,
          fontSize: (theme) => theme.utils.important(componentsFontSizes.input),
        },
      },
    }),
    [disabled, theme],
  );

  return commonProps;
}
